import React, { useRef, useCallback, useState } from "react";
import Webcam from "react-webcam";
import "../App.css"; // Reuse existing styles or add specific ones

const videoConstraints = {
    width: 1280,
    height: 720,
    facingMode: "user"
};

const Camera = ({ onCapture, onCancel }) => {
    const webcamRef = useRef(null);
    const [isCapturing, setIsCapturing] = useState(false);

    const capture = useCallback(() => {
        setIsCapturing(true);
        const imageSrc = webcamRef.current.getScreenshot();
        if (imageSrc) {
            onCapture(imageSrc);
        } else {
            setIsCapturing(false); // Reset if failed
        }
    }, [webcamRef, onCapture]);

    return (
        <div className="camera-container">
            <div className="camera-wrapper">
                <Webcam
                    audio={false}
                    height={720}
                    ref={webcamRef}
                    screenshotFormat="image/jpeg"
                    width={1280}
                    videoConstraints={videoConstraints}
                    className="webcam-view"
                />
                <div className="camera-overlay">
                    <p className="camera-instruction">Mira a la cámara para identificarte</p>
                </div>
            </div>

            <div className="camera-controls">
                <button className="secondary-button" onClick={onCancel}>
                    Cancelar
                </button>
                <button
                    className="capture-button"
                    onClick={capture}
                    disabled={isCapturing}
                >
                    {isCapturing ? "Procesando..." : "📸 Escanear Cara"}
                </button>
            </div>
        </div>
    );
};

export default Camera;
